export type WorkspaceView = "customer" | "partner" | "owner";

export function workspaceForPath(pathname: string): WorkspaceView {
  if (pathname.startsWith("/owner")) return "owner";
  if (pathname.startsWith("/partner/apply")) return "customer";
  if (pathname.startsWith("/partner")) return "partner";
  return "customer";
}

export function canUseWorkspace(
  view: WorkspaceView,
  session: { isOwner: boolean; isPartner: boolean; partnerApplicationStatus?: string | null },
): boolean {
  if (view === "customer") return true;
  if (view === "owner") return session.isOwner;
  // Owners can inspect the Partner workspace without granting themselves the
  // marketplace Partner role. Marketplace actions remain protected by their
  // existing server-side role/ownership checks.
  return session.isOwner || (session.isPartner && session.partnerApplicationStatus === "approved");
}
